import type {
  BusinessUnitChargingWeb2CaseFormValues,
  ManufacturerOption,
  QuestionTypeOption,
  ShippingTypeOption,
} from './BusinessUnitChargingWeb2CaseForm.schema';

export const INITIAL_VALUES: BusinessUnitChargingWeb2CaseFormValues = {
  first_name: '',
  last_name: '',
  company: '',
  postal_code: '',
  street: '',
  city: '',
  phone: '',
  email: '',
  question: undefined,
  message: undefined,
  invoice_order_number: undefined,
  order_number: undefined,
  manufacturer: undefined,
  location_of_charging_infrastrucutre: undefined,
  'g-recaptcha-response': '',
};

export const QUESTION_OPTIONS: QuestionTypeOption[] = [
  {
    label: 'Rechnung / Bezahlung',
    value: 'Invoice / Payment',
  },
  {
    label: 'Versand / Lieferung',
    value: 'Shipping / Delivery',
  },
  {
    label: 'Reklamation',
    value: 'Complaint',
  },
  {
    label: 'Verwendung eines Produkts',
    value: 'Use of a product',
  },
];

export const MANUFACTURER_OPTIONS: ManufacturerOption[] = [
  {
    label: 'KEBA',
    value: 'keba',
  },
  {
    label: 'Alfen',
    value: 'alfen',
  },
  {
    label: 'Webasto/Ampure',
    value: 'webasto/ampure',
  },
  {
    label: 'EVBox',
    value: 'evbox',
  },
  {
    label: 'ABL/Wallbox',
    value: 'abl/wallbox',
  },
  {
    label: 'go-e',
    value: 'go-e',
  },
  {
    label: 'NRGkick',
    value: 'nrgkick',
  },
  {
    label: 'Juice',
    value: 'juice',
  },
  {
    label: 'Sonstige',
    value: 'sonstige',
  },
];

export const SHIPPING_DELIVERY_OPTIONS: ShippingTypeOption[] = [
  {
    label: 'Ware beim Transport beschädigt',
    value: 'ware_beim_transport_beschadigt',
  },
  {
    label: 'Bestellstatus meiner Ware',
    value: 'bestellstatus_meiner_ware',
  },
  {
    label: 'Etwas anderes',
    value: 'etwas_anderes',
  },
];
